import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_BASE_URL =  process.env.REACT_APP_API_PLAN_URL;

// 1. تحديث الأكشن ليأخذ planId (الهاش) ويرسله في الرابط
export const fetchDailyPlan = createAsyncThunk(
  'session/fetchDailyPlan',
  async (planId, { rejectWithValue }) => {
    try {
  // جلب التوكن من التخزين المحلي
  const token = localStorage.getItem('userToken');

  // تنظيف المعرف بإزالة أي علامات اقتباس مزدوجة أو مفردة تحيط به
  const cleanPlanId = planId.replace(/['"]/g, '');

  // إرسال الطلب مع تمرير cleanPlanId المنظف داخل الرابط
  const response = await axios.get(`${API_BASE_URL}assessment-criteria/get-daily-plan/${cleanPlanId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    }
  });

  // إرجاع كائن data الموجود داخل الرد
  console.log("معلومات الخطة الكاملة",response.data.data)
  return response.data.data; 
}catch (error) {
      console.error(error);
      return rejectWithValue(
        error.response?.data?.message || "حدث خطأ أثناء جلب الخطة اليومية من السيرفر"
      );
    }
  }
);

// 2. هيكلة الحالة (State)
const sessionSlice = createSlice({
  name: 'session',
  initialState: {
    // معلومات الدرس
    lesson: { title: '', time: '', date: '', order: null },
    // معلومات المادة والصف
    subject: { id: '', name: '' },
    classInfo: { id: '', name: '' },
    // معلومات المعلم والمدرسة
    teacher: { id: '', name: '', image: null },
    school: { id: '', name: '' },
    // المعايير مدمجة في مصفوفة واحدة
    criteria: [], 
    Duration: null, // تمت الإضافة هنا
    
    loading: false,
    error: null,
  },
  reducers: {
    clearSessionData: (state) => {
      state.lesson = { title: '', time: '', date: '', order: null };
      state.subject = { id: '', name: '' };
      state.classInfo = { id: '', name: '' };
      state.teacher = { id: '', name: '', image: null };
      state.school = { id: '', name: '' };
      state.criteria = [];
      state.Duration = null; // تم تصحيح الفاصلة إلى فارزة منقوطة
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDailyPlan.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDailyPlan.fulfilled, (state, action) => {
        state.loading = false;
        
        // action.payload هنا يمثل كائن الـ data الداخلي
        const d = action.payload; 

        // توزيع البيانات بشكل نظيف في الحالة
        state.lesson = { title: d.lessonTitle, time: d.lessonTime, date: d.lessonDate, order: d.lessonOrder };
        state.subject = { id: d.subjectId, name: d.subjectName };
        state.classInfo = { id: d.classId, name: d.className };
        state.teacher = { id: d.teacherId, name: d.teacherName, image: d.teacherImage };
        state.school = { id: d.schoolId, name: d.schoolName };
        
        // تصحيح: أخذ قيمة Duration من الكائن d
        state.Duration = d.Duration; 

        // دمج assessmentCriteriaId و assessmentCriteriaTitle في مصفوفة كائنات مرتبة
        if (d.assessmentCriteriaId && d.assessmentCriteriaTitle) {
          state.criteria = d.assessmentCriteriaId.map((id, index) => ({
            id: id,
            title: d.assessmentCriteriaTitle[index]
          }));
        } else {
          state.criteria = [];
        }
      })
      .addCase(fetchDailyPlan.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearSessionData } = sessionSlice.actions;
export default sessionSlice.reducer;